import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="footer-wrap mt-auto">
      <div className="container py-4 text-center small">
        © 2025 Khoa học Tâm Linh — Thiết kế & phát triển bởi Đỗ Khắc Gia Khoa
      </div>
    </footer>
  );
}
